export const shell = "mx-auto w-full max-w-[1280px] px-5 sm:px-6 lg:px-8";

export const primaryLink =
  "inline-flex h-11 items-center justify-center gap-2 rounded-[10px] bg-[var(--m-accent)] px-4 text-[15px] font-semibold text-white transition-colors hover:bg-[var(--m-accent-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--m-accent)]";

export const primaryLinkCompact =
  "inline-flex h-10 items-center justify-center rounded-[10px] bg-[var(--m-accent)] px-4 text-sm font-semibold text-white transition-colors hover:bg-[var(--m-accent-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--m-accent)]";

export const secondaryLink =
  "inline-flex h-11 items-center justify-center rounded-[10px] border border-[var(--m-line)] bg-white px-4 text-[15px] font-semibold text-[var(--m-ink)] transition-colors hover:bg-[var(--m-soft)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--m-accent)]";

export const sectionTitle =
  "text-[1.6rem] leading-tight font-semibold tracking-[-0.03em] text-[var(--m-ink)] sm:text-[1.85rem]";

export const sectionLinks = [
  { href: "/#capabilities", label: "Возможности" },
  { href: "/#how", label: "Как это работает" },
  { href: "/pricing", label: "Тариф" },
] as const;

export function cabinetOr(signedIn: boolean, guest: { href: string; label: string }) {
  if (signedIn) {
    return { href: "/app", label: "Перейти в кабинет" };
  }
  return guest;
}
